import { render, staticRenderFns } from "./AdvancedCusRemittanceList.vue?vue&type=template&id=6b56f3c7&scoped=true&"
import script from "./AdvancedCusRemittanceList.vue?vue&type=script&lang=js&"
export * from "./AdvancedCusRemittanceList.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedCusRemittanceList.vue?vue&type=style&index=0&id=6b56f3c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b56f3c7",
  null
  
)

export default component.exports